<div class="delivery-upcoming-events-view-part">
	<grid-content [setup]="setup" [namedSize]="'TabContent'" [pageTabsGridSize]="pageTabsGridSize()"
		[rows]="upcomingEvents()"></grid-content>
</div>